// Studio-themed background: a tiled SVG of mic / headphone / soundwave glyphs
// in red + blue at low opacity. Drop into any section as an absolute layer.
import React from "react";

const TILE = encodeURIComponent(`
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 240 240' width='240' height='240'>
  <g fill='none' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'>
    <!-- Mic 1 (red) -->
    <g stroke='#E10600' opacity='0.45' transform='translate(24 22)'>
      <rect x='10' y='0' width='14' height='22' rx='7' />
      <path d='M3 18 a14 14 0 0 0 28 0' />
      <path d='M17 32 v8' />
      <path d='M11 40 h12' />
    </g>
    <!-- Headphone (blue) -->
    <g stroke='#1E6FE0' opacity='0.45' transform='translate(140 28)'>
      <path d='M2 22 a20 20 0 0 1 40 0' />
      <rect x='0' y='22' width='8' height='16' rx='2' />
      <rect x='36' y='22' width='8' height='16' rx='2' />
    </g>
    <!-- Soundwave (red) -->
    <g stroke='#E10600' opacity='0.40' transform='translate(20 110)'>
      <path d='M0 12 L4 12 M10 4 L10 20 M16 0 L16 24 M22 6 L22 18 M28 2 L28 22 M34 8 L34 16 M40 12 L40 12 M46 4 L46 20 M52 0 L52 24 M58 6 L58 18 M64 2 L64 22' />
    </g>
    <!-- Vinyl (blue) -->
    <g stroke='#1E6FE0' opacity='0.40' transform='translate(150 110)'>
      <circle cx='24' cy='24' r='22' />
      <circle cx='24' cy='24' r='12' />
      <circle cx='24' cy='24' r='3' fill='#1E6FE0' />
    </g>
    <!-- ON AIR text (red) -->
    <g transform='translate(28 200)'>
      <rect x='0' y='0' width='52' height='14' fill='none' stroke='#E10600' opacity='0.4' />
      <text x='26' y='10' text-anchor='middle' fill='#E10600' opacity='0.5' font-family='monospace' font-size='8' font-weight='700' letter-spacing='2'>ON AIR</text>
    </g>
    <!-- EQ bars (blue) -->
    <g fill='#1E6FE0' opacity='0.4' transform='translate(140 195)'>
      <rect x='0' y='8' width='3' height='14' />
      <rect x='6' y='0' width='3' height='22' />
      <rect x='12' y='10' width='3' height='12' />
      <rect x='18' y='4' width='3' height='18' />
      <rect x='24' y='12' width='3' height='10' />
      <rect x='30' y='2' width='3' height='20' />
      <rect x='36' y='8' width='3' height='14' />
      <rect x='42' y='0' width='3' height='22' />
    </g>
  </g>
</svg>
`);

export default function StudioBackdrop({
  opacity = 0.55,
  className = "",
  size = 240,
  fade = true,
}) {
  const style = {
    backgroundImage: `url("data:image/svg+xml;utf8,${TILE}")`,
    backgroundRepeat: "repeat",
    backgroundSize: `${size}px ${size}px`,
    opacity,
  };
  return (
    <div
      aria-hidden
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={style}
    >
      {fade && (
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at center, transparent 0%, rgba(10,10,10,0.85) 75%)",
          }}
        />
      )}
    </div>
  );
}
